<template>
  <div class="cta" :class="[bgColor, layoutClass]">
    <div class="cta__img" v-if="image">
      <img
        class="md-max:max-w-sm mx-auto block max-h-56"
        :src="image.src"
        :alt="image.alt" />
    </div>
    <div class="cta__body space-y-20px" :class="{ 'text-center': centerText }">
      <Title :headingTag="'h2'" :style="'h2'" :class="textColorClass">
        <slot name="title">{{ titleText }}</slot>
      </Title>
      <Paragraphs
        v-if="bodyText"
        isHighlight
        :text="bodyText"
        :color="textColor">
      </Paragraphs>
    </div>
    <div class="cta__btn text-center" v-if="button">
      <Button
        :tag="button.tag ? button.tag : 'a'"
        :style="'primary'"
        :link="button.link">
        {{ button.text }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "../Atoms/Button.vue";
import Footnotes from "../Atoms/Footnotes.vue";
import Paragraphs from "../Atoms/ParagraphsNew.vue";
import Title from "../Atoms/Heading.vue";
import { computed } from "@vue/runtime-core";
import { useCustomValidator } from "../../compostables/useValidators";
import useHasSlot from "../../compostables/useHasSlot";

export default {
  components: {
    Button,
    Footnotes,
    Paragraphs,
    Title,
  },

  props: {
    button: {
      type: Object,
      required: false,
      default: null,
    },
    bgColor: {
      type: String,
      required: false,
      default: "none",
      validator(value) {
        return useCustomValidator(
          ["orange", "blue", "gray", "white", "none"],
          value
        );
      },
    },
    centerText: {
      type: Boolean,
      required: false,
      default: false,
    },
    image: {
      type: Object,
      required: false,
    },
    layout: {
      type: String,
      required: false,
      default: "normal",
      validator(value) {
        return useCustomValidator(
          [
            "img-body-btn",
            "body-btn-img",
            "body-btn",
            "body-btn-inline",
            "img-body",
          ],
          value
        );
      },
    },
    bodyText: {
      type: String,
      required: false,
    },
    titleText: {
      type: String,
      required: true,
    },
  },

  setup(props, { slots }) {
    const { hasSlot } = useHasSlot(slots);

    // Set classes for text color based on bg color
    const textColorClass = computed(() => ({
      "text-navy":
        props.bgColor === "blue" ||
        props.bgColor === "orange" ||
        props.bgColor === "gray",
      "text-white": props.bgColor === "navy",
    }));

    // Set class for bg color
    const bgColor = computed(() => ({
      "bg-navy": props.bgColor === "navy",
      "bg-orange-100": props.bgColor === "orange",
      "bg-light-gray-400": props.bgColor === "gray",
      "bg-light-blue-2": props.bgColor === "blue",
      "bg-white": props.bgColor === "white",
      "bg-transparent": props.bgColor === "none",
    }));

    const textColor = computed(() => {
      if (props.bgColor === "navy") {
        return "white";
      }
    });

    const layoutClass = computed(() => "cta--" + props.layout);

    return {
      hasSlot,
      bgColor,
      layoutClass,
      textColorClass,
      textColor,
    };
  },
};
</script>
